<template>
  <span>
    <div class="col-md-12">
      <div class="table-responsive">
        <table id="dataTableExample" class="table table-hover">
          <thead>
            <tr>
              <th>Sr. No.</th>
              <th>Type</th>
              <th>Speed</th>
              <th>B/L</th>
              <th>HFO/LSFO</th>
              <th>MDO</th>
              <th>LSMG</th>
              <th class="text-center">Action</th>
            </tr>
          </thead>
          <tbody>
            <loading-table :isLoading="isLoading" cols="14"></loading-table>
            <tr v-if="form.vessel_speeds.length == 0">
              <td colspan="14" class="text-center">No data Found</td>
            </tr>
            <tr
              v-for="(vesselSpeed, ar) in form.vessel_speeds"
              :key="`vesselSpeed${ar}`"
            >
              <td>{{ ar + 1 }}.</td>
              <td>
                <input
                  v-uppercase
                  type="text"
                  class="form-control"
                  placeholder="Type"
                  v-model="vesselSpeed.type"
                />
              </td>
              <td>
                <input
                  v-uppercase
                  type="text"
                  class="form-control"
                  placeholder="Speed"
                  v-model="vesselSpeed.speed"
                />
              </td>
              <td>
                <input
                  v-uppercase
                  type="text"
                  class="form-control"
                  placeholder="B/L"
                  v-model="vesselSpeed.b_l"
                />
              </td>
              <td>
                <input
                  v-uppercase
                  type="text"
                  class="form-control"
                  placeholder="HFO/LSFO"
                  v-model="vesselSpeed.hfo_lsfo"
                />
              </td>
              <td>
                <input
                  v-uppercase
                  type="text"
                  class="form-control"
                  placeholder="MDO"
                  v-model="vesselSpeed.mdo"
                />
              </td>
              <td>
                <input
                  type="text"
                  placeholder="LSMG"
                  v-model="vesselSpeed.lsmg"
                  class="form-control"
                />
              </td>

              <td>
                <div class="text-center">
                  <button
                    class="btn btn-danger btn-sm"
                    @click="deleteVesselSpeed(vesselSpeed)"
                    v-if="!vesselSpeed.id"
                  >
                    Delete
                  </button>
                  <button
                    class="btn btn-danger btn-sm"
                    @click="delete_vessel_speed_data(vesselSpeed.id)"
                    v-else
                  >
                    Delete
                  </button>
                </div>
              </td>
            </tr>
            <tr v-if="form.vessel_speeds">
              <td
                colspan="14"
                align="center"
                @click="addEmptyVesselSpeeds()"
                style="
                  background-color: #6571ff;
                  color: white;
                  border-radius: 10px;
                  box-shadow: none;
                "
              >
                Add New Row
              </td>
            </tr>
          </tbody>
        </table>
        <!-- /Table -->
      </div>
    </div>
  </span>
</template>

<script type="text/javascript">
import axios from "axios";
export default {
  name: "Vessel2FormWidget",
  props: ["form"],
  emits: ["getData"],
  methods: {
    addEmptyVesselSpeeds() {
      this.form.vessel_speeds.push({
        type: "",
        speed: "",
        b_l: "",
        hfo_lsfo: "",
        mdo: "",
        lsmg: "",
      });
    },
    deleteVesselSpeed(speed) {
      this.form.vessel_speeds = this.form.vessel_speeds.filter(
        (ar) => ar != speed
      );
    },
    async delete_vessel_speed_data(id) {
      let check = confirm("Are you sure you want to delete the data");
      if (check) {
        try {
          this.isLoading = true;
          await axios.post(`delete?id=${id}&table_name=vessel_speeds`);
          this.isLoading = false;
          this.$emit("getData");
        } catch (e) {
          this.isLoading = false;
        }
      }
    },
  },
};
</script>
